import { useCallback } from 'react';
import invariant from 'tiny-invariant';

import { convertUnknownToError, reportErrorToBugsnag } from '@air/utils-error';

import { useReCaptcha } from '~/providers/ReCaptchaProvider';
import { isCypressRun } from '~/utils/PathUtils';

export const useGetRecaptchaToken = () => {
  const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
  invariant(siteKey, 'RECAPTCHA_SITE_KEY is not defined');

  const { executeRecaptcha, isReady } = useReCaptcha();

  const getRecaptchaToken = useCallback(async () => {
    if (isCypressRun()) {
      // Return dummy token for cypress, it will be ignored anyway
      return 'test-token';
    }

    if (!isReady) {
      console.error('ReCaptcha not ready');
      return null;
    }

    try {
      return await executeRecaptcha();
    } catch (error) {
      reportErrorToBugsnag({
        error: convertUnknownToError(error),
        context: 'Can not get ReCaptcha token',
      });
      throw error;
    }
  }, [executeRecaptcha, isReady]);

  return { getRecaptchaToken };
};
